module.exports = __webpack_public_path__ + "static/media/thumbnail.68974613.jpg";